
import { Input, Checkbox, Drawer } from "element-ui"
import drawerHeader from "../drawer/components/drawerHeader.vue"
import editRecipient from "../drawer/editRecipient.vue"
import { getConsignInfo } from "@/api/cart"
import { getCurrentAddress } from "@/utils/utils"

export default {
  components: {
    [Checkbox.name]: Checkbox,
    [Input.name]: Input,
    [Drawer.name]: Drawer,
    editRecipient,
    drawerHeader
  },
  props: {
    info: {
      type: Object,
      default: () => {}
    },
    checkoutParams: {
      type: Object,
      default: () => {}
    },
    isPickup: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      name: "",
      code: "",
      num: "",
      phoneIsEdit: false,
      insIsEdit: false,
      instruction: {
        addDef1: false,
        addDef2: false,
        content: ""
      },
      insStr: ""
    }
  },
  computed: {
    recipientInfo() {
      return {
        name: this.name || "",
        num: this.num || "",
        code: this.code || ""
      }
    }
  },
  watch: {
    info: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length) {
          this.name = newVal.consignee
          if (newVal.mobilPhone && newVal.mobilPhone.includes(" ")) {
            this.code = newVal.mobilPhone.split(" ")[0]
            this.num = newVal.mobilPhone.split(" ")[1]
            // +
            if (!this.code.includes("+")) {
              this.code = "+" + this.code
            }
          } else {
            this.num = newVal.mobilPhone
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    async handleCheckout({ name, num, code }) {
      const addrItem = getCurrentAddress()
      try {
        const params = {
          phone: `${code} ${num}`,
          userName: encodeURIComponent(name),
          consignee: encodeURIComponent(name),
          type: addrItem.type,
          id: this.info.id,
          address2: encodeURIComponent(this.info.addressName),
          unitFloor: encodeURIComponent(this.info.addressDetail),
          lng: this.info.longitude,
          lat: this.info.latitude,
          label: encodeURIComponent(addrItem.label),
          priority: addrItem.priority
        }
        const res = await getConsignInfo({ param: JSON.stringify(params) })

        this.$navigation.replace({
          path: "/checkout",
          query: {
            params: JSON.stringify({
              ...this.checkoutParams,
              addressId: (res && res.id) || ""
            })
          }
        })
        this.$emit("changed")
      } catch (error) {
        console.log(error)
      }
    },
    onRecipientClose() {
      this.phoneIsEdit = false
    },
    onRecipientSave(val) {
      if (!val.name) {
        this.$message({
          message: "请输入姓名",
          type: "warning"
        })
      } else if (!val.code || !val.num) {
        this.$message({
          message: "请输入手机号",
          type: "warning"
        })
      } else {
        this.phoneIsEdit = false
        if (this.isPickup) {
          this.name = val.name
          this.code = val.code
          this.num = val.num
          this.$emit("pickupChanged", val)
        } else {
          this.handleCheckout(val)
        }
      }
    },
    handleSaveIns() {
      let str = ""
      if (this.instruction.addDef1) {
        str += this.$t("checkout.mark1") + ";\n"
      }
      if (this.instruction.addDef2) {
        str += this.$t("checkout.mark2") + ";\n"
      }
      str += this.instruction.content + "\n"
      this.insStr = str
      this.insIsEdit = false
      this.$emit("ins-changed", this.insStr)
    },
    getDisplayStore() {
      const curSelStore = localStorage.getItem("curSelStore") ? JSON.parse(localStorage.getItem("curSelStore")) : {}
      return curSelStore
    }
  }
}
